let checkTouch = function() {
  let $html = $('html');

  if ('ontouchstart' in document.documentElement) {
    $html.removeClass('no-touchevents');
    $html.addClass('touchevents');
  }

  if ($html.hasClass('no-touchevents')) {
    $(window).on('touchstart.touchTest', function () {
      $html.removeClass('no-touchevents');
      $html.addClass('touchevents');
      $(window).off('touchstart.touchTest');
    });
  }
};

checkTouch();


// WEBPACK FOOTER //
// ./scripts/util/checkTouch.js